import { connect } from 'react-redux'
import so3CorrectionForm from '../ui/forms/so3CorrectionForm'
import { setSo3CorrectionAction } from '../../store/actions/so3CorrectionActions'

const mapStateToProps = state => ({
    formValues: state.formulas.so3Correction
})

const mapDispatchToProps = dispatch => {
    return {
        formToState: (val) => {
            dispatch(
                setSo3CorrectionAction(val)
            )
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(so3CorrectionForm)